/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */

(function () {
  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  // document.addEventListener("theme:variant:change", function (event) {
  //   // You might use something like this to write a pre-order feature or a
  //   // custom swatch feature.
  //   var variant = event.detail.variant;
  //   var container = event.target;
  //   if (variant) {
  //     console.log("Container ———————— ↓");
  //     console.log(container);
  //     console.log("Variant —————————— ↓");
  //     console.log(variant);
  //     // ... update some element on the page
  //   }
  // });

  // document.addEventListener("theme:cart:change", function (event) {
  //   var cart = event.detail.cart;
  //   if (cart) {
  //     console.log("Cart ———————————— ↓");
  //     console.log(cart);
  //     // ... update an app or a custom shipping caluclator
  //   }
  // });
  // Fired when page loads to update header values
  // document.addEventListener("theme:cart:init", (e) => {
  //   console.log("theme:cart:init");
  //   console.log(e);
  // });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  // document.addEventListener("theme:scroll", (e) => {
  //   console.log(e);
  // });
  // document.addEventListener("theme:scroll:up", (e) => {
  //   console.log(e);
  // });
  // document.addEventListener("theme:scroll:down", (e) => {
  //   console.log(e);
  // });

  // Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener("theme:resize", (e) => {
  //   console.log(e);
  // });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the
  // scroll locking code knows what element should maintain scoll.
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();


$(document).ready(function () {
  if($('.r-16vozny').length) {
    $('.r-16vozny').find('span p').html('<span>not sure which brew is for you?</span>');
  }
  
  var $slickEl = $(".main--product-slider");

  $slickEl.slick({
    centerMode: true,
    centerPadding: "100px",
    slidesToShow: 5,
    focusOnSelect: true,
    dots: false,
    infinite: true,
    prevArrow:
      '<button type="button" class="slick-prev pull-left">' +
      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M15 18L9 12L15 6" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>' +
      "</svg>" +
      "</button>",
    nextArrow:
      '<button type="button" class="slick-next pull-right">' +
      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M9 18L15 12L9 6" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>' +
      "</svg></button>",
    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerMode: true,
          centerPadding: "40px",
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          centerMode: true,
          centerPadding: "40px",
          slidesToShow: 1,
        },
      },
    ],
  });

  $slickEl.on("afterChange", function (event, slick, currentSlide) {
    var currentSlideElement = $(slick.$slides[currentSlide]);
    var currentSlideDataAttr = currentSlideElement.attr("id");
    // console.log('After Change:');
    // console.log('Current Slide Data:', currentSlideDataAttr);
    $(".product__details--main").hide();
    $(`.product__details--main[data-target="${currentSlideDataAttr}"]`).show();
  });

  $slickEl.on("afterChange", function (event, slick, currentSlide) {
    var currentSlideElement = $(slick.$slides[currentSlide]);
    var currentSlideDataAttr = currentSlideElement.attr("id");
    // console.log('After Change:');
    // console.log('Current Slide Data:', currentSlideDataAttr);
    $(".product__details--main").hide();
    $(`.product__details--main[data-target="${currentSlideDataAttr}"]`).show();
  });

  $(".ptl__tab--product").slick({
    slidesToShow: 3.5,
    focusOnSelect: false,
    dots: false,
    infinite: false,
    centerMode: false,
    prevArrow:
      '<button type="button" class="slick-prev pull-left">' +
      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M15 18L9 12L15 6" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>' +
      "</svg>" +
      "</button>",
    nextArrow:
      '<button type="button" class="slick-next pull-right">' +
      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M9 18L15 12L9 6" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>' +
      "</svg></button>",
    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerMode: false,
          centerPadding: "0px",
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          centerMode: false,
          centerPadding: "0px",
          slidesToShow: 1.2,
        },
      },
    ],
  });

  $(".tab-title").click(function () {
    $(".tab-title").removeClass("active");
    $(this).addClass("active");
    var index = $(this).attr("data-index");

    $(".ptl__tab--product").hide().removeClass("active");
    $(".ptl__tab--product.tabcontent-" + index)
      .show()
      .addClass("active");
    $(".ptl__tab--product").slick("refresh");
  });

    setTimeout(function() {
        const $container = $('.tolstoy-stories-tiles-container');

        if ($container.length) {
            const indicesToRemove = [3, 4, 6, 7, 15, 16];

            indicesToRemove.sort((a, b) => b - a).forEach(index => {
                $container.children(':nth-child(' + index + ')').remove();
            });
        }
    }, 2000);
  
});

const zodiacSigns = [
  "aquarius",
  "pisces",
  "aries",
  "taurus",
  "gemini",
  "cancer",
  "leo",
  "virgo",
  "libra",
  "scorpio",
  "sagittarius",
  "capricorn",
];

// Store the current zodiac sign (instead of using URL hash)
let currentZodiacSign = "";

function getZodiacSign(day, month) {
  if ((month == 1 && day >= 20) || (month == 2 && day <= 18)) return "aquarius";
  if ((month == 2 && day >= 19) || (month == 3 && day <= 20)) return "pisces";
  if ((month == 3 && day >= 21) || (month == 4 && day <= 19)) return "aries";
  if ((month == 4 && day >= 20) || (month == 5 && day <= 20)) return "taurus";
  if ((month == 5 && day >= 21) || (month == 6 && day <= 20)) return "gemini";
  if ((month == 6 && day >= 21) || (month == 7 && day <= 22)) return "cancer"; // Cancer
  if ((month == 7 && day >= 23) || (month == 8 && day <= 22)) return "leo";
  if ((month == 8 && day >= 23) || (month == 9 && day <= 22)) return "virgo";
  if ((month == 9 && day >= 23) || (month == 10 && day <= 22)) return "libra";
  if ((month == 10 && day >= 23) || (month == 11 && day <= 21)) return "scorpio";
  if ((month == 11 && day >= 22) || (month == 12 && day <= 21)) return "sagittarius";
  if ((month == 12 && day >= 22) || (month == 1 && day <= 19)) return "capricorn";
  return "";
}

function handleSubmit() {
  var day = document.getElementById("birth-day").value;
  var month = document.getElementById("birth-month").value;

  if (!day || !month) {
    alert("Please select both day and month.");
    return;
  }

  var zodiacSign = getZodiacSign(parseInt(day), parseInt(month));

  // Check if a valid zodiac sign was determined
  if (zodiacSign) {
    currentZodiacSign = zodiacSign; // Store the initial zodiac sign
    scrollToProducts();
    setTimeout(() => showInitialSlide(zodiacSign), 100); // Delay to ensure proper activation
  } else {
    alert("Unable to determine zodiac sign.");
  }
}

// Improved scroll function
function scrollToProducts() {
  const productSection = document.querySelector(
    '[data-section-type="product-list"]'
  );
  if (productSection) {
    productSection.scrollIntoView({
      behavior: "smooth",
      block: "start", // Ensure it scrolls to the top of the section
    });
    setTimeout(() => window.scrollBy(0, -50), 1500); // Adjust this offset as needed
  }
}

function showInitialSlide(zodiacSign) {
  const slides = document.querySelectorAll("[data-slide]");
  slides.forEach((slide) => {
    slide.classList.remove("active");
    // slide.style.opacity = '0.4'; // Set opacity to 0.4 for all slides
  });
  $(".product__details--main").hide();
  const activeSlide = document.querySelector(`[data-slide="${zodiacSign}"]:not(.slick-cloned)`);

  if (activeSlide) {
    $(`.product__details--main[data-product="${zodiacSign}"]`).show();
    activeSlide.classList.add("active"); // Make it visible
    activeSlide.style.opacity = "1"; // Ensures it's fully visible
    activeSlide.style.visibility = "visible"; // Ensure it's visible

    // Get the data-slick-index value
    let slickIndex = Math.abs(parseInt(activeSlide.getAttribute("data-slick-index"), 10));
    console.log(`Active slide index for ${zodiacSign}: ${slickIndex}`);

    setTimeout(function () {
      $(".main--product-slider").slick("slickGoTo", slickIndex);
    }, 800);

    console.log(`Showing slide for ${zodiacSign}`);
  } else {
    console.error(`No slide found for ${zodiacSign}`); // Debugging log in case no matching slide is found
  }
}

// Ensure correct slide is shown on page load based on stored zodiac sign
window.addEventListener("load", function () {
  var data_slide = $(
    ".product_slide.slick-slide.slick-current.slick-active.slick-center"
  ).attr("data-slide");
  if (data_slide) {
    $(`.product__details--main[data-product="${data_slide}"]`).show();
  }
  if (currentZodiacSign) {
    console.log(currentZodiacSign);
    showInitialSlide(currentZodiacSign);
  }
});

function showVariantPopup(title) {
        const $popupElement = $('#variant-added-popup');
        const $titleElement = $('#variant-title span');

        if ($titleElement.length) {
            $titleElement.text(title);
        }

        if ($popupElement.length) {
            $popupElement.css('display', 'flex');
            setTimeout(() => {
                $popupElement.css('display', 'none');
            }, 3000);
        }
    }

$(document).on("click", ".atc__btn-ajx", function () {
  $(this).find(".loading_btn").show();
  $(this).find(".btn__text").hide();
  var $wrap = $(this).closest(".prd_variant-wrap"); // Use closest to find the parent wrapper
  var $option = $wrap.find(".product__variants"); // Find the select element
  var selectedValue = $option.val(); // Get the selected value

  console.log("Selected Option Value:", selectedValue);
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      quantity: 1,
      id: selectedValue,
    },
    dataType: "json",
    success: function (data) {
      console.log(data.quantity);
      setTimeout(function () {
        showVariantPopup(data.product_title);
        $(".atc__btn-ajx").find(".loading_btn").hide();
        $(".atc__btn-ajx").find(".btn__text").show();
      }, 1000);
      $(document).trigger("theme:cart:popdown", [data]);
    },
  });
});

$(document).ready(function () {
    $('body').on('change', '.product__variants', function () {
        const $selectElement = $(this);
        const $selectedOption = $selectElement.find('option:selected');
        const variantPrice = $selectedOption.data('variant-price');

        const $parentElement = $selectElement.closest('.product__details-main, .product-grid-item');

        if (!$parentElement.length) {
            return;
        }

        const $priceSpan = $parentElement.find('.prd_price');

        if ($priceSpan.length) {
            $priceSpan.text(variantPrice);
        } else {
            console.error("Price element not found in parent element:", $parentElement);
        }
    });
});
